import { render, staticRenderFns } from "./add-exam-form-controller.vue?vue&type=template&id=b38c6d0e&scoped=true"
import script from "./add-exam-form-controller.vue?vue&type=script&lang=ts"
export * from "./add-exam-form-controller.vue?vue&type=script&lang=ts"
import style0 from "./add-exam-form-controller.vue?vue&type=style&index=0&id=b38c6d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38c6d0e",
  null
  
)

export default component.exports